module.exports = __webpack_public_path__ + "media/images/performance_index_continuum-a8f773e59775c53e03a9daa932f5306d.png";